import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationHistoryService {

  history: string[] = [];

  constructor(private router: Router) {
    // Subscribe to navigation end events and add the current URL to the history
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.addToHistory(event.urlAfterRedirects);
      }
    });
  
    // Listen to popstate events on the window and remove the last item from the history
    window.addEventListener('popstate', () => {
      this.removeFromHistory();
    });
    
    // Clear the history and the map on refresh
    window.onbeforeunload = () => {
      this.clearHistory();
      return null;
    };
  }

  addToHistory(path: string) {
    // Check if the current URL is already in the history array
    const index = this.history.indexOf(path);
    if (index !== -1) {
      // If the current URL is already in the history array, remove it and all links that come after it
      this.history.splice(index);
    } else {
      // If the current URL is not in the history array, remove all links that come after the current URL
      const currentPathIndex = this.history.length - 1;
      if (currentPathIndex >= 0 && this.history[currentPathIndex] !== path) {
        const lastIndexOfPath = this.history.lastIndexOf(path);
        if (lastIndexOfPath !== -1) {
          this.history.splice(lastIndexOfPath + 1);
        }
      }
    }
    // Add the current URL to the end of the history array
    this.history.push(path);
  }  

  removeFromHistory() {
    const currentUrl = this.router.url;
    const lastUrl = this.history[this.history.length - 1];
    if (currentUrl !== lastUrl) {
      this.history.pop();
    }
  }

  clearHistory() {
    this.history = [];
  }
}